import {mapActions} from 'vuex'
import * as types from '@/store/types'
import CookieHelper from '@/utils/cookie-helper'

export default {
    name: 'Success',
    methods: {
        ...mapActions({
            guiTryInitSet: types.GUI.tryInit.set,
            appClientSet: types.APP.client.set,
            appServicingSet: types.APP.servicing.set,
            appQueueSet: types.APP.queue.set,
            appPhoneSet: types.APP.phone.set
        })
    },
    beforeMount() {
        this.appClientSet(null)
        this.appServicingSet(null)
        this.appQueueSet(null)
        this.appPhoneSet(null)
        CookieHelper.delClientId(this.$cookie)
    }
}
